
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata, EmployeePayHistoryServiceParameters, EmployeePayHistoryViewModel, ExecutionResult, PacketViewModel, VoidPaymentViewModel } from "@tylertech/tyler-api-types";

/**
 * EmployeePayHistoryService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class EmployeePayHistoryService {
    private readonly $apiService = inject(ApiService);
    
    CreatePayrollCorrectionProcess(parameters: EmployeePayHistoryServiceParameters): Promise<ExecutionResult<PacketViewModel>> {
        return this.$apiService.sendAuth("IEmployeePayHistoryService/CreatePayrollCorrectionProcess", parameters);
    }
    CreatePayrollCorrectionProcessesForHeaders(parameters: EmployeePayHistoryServiceParameters): Promise<ExecutionResult<PacketViewModel>> {
        return this.$apiService.sendAuth("IEmployeePayHistoryService/CreatePayrollCorrectionProcessesForHeaders", parameters);
    }
    CreatePayrollProcessForReverseAndReissue(parameters: EmployeePayHistoryServiceParameters): Promise<ExecutionResult<PacketViewModel>> {
        return this.$apiService.sendAuth("IEmployeePayHistoryService/CreatePayrollProcessForReverseAndReissue", parameters);
    }
    CreatePayrollProcessForVoid(parameters: EmployeePayHistoryServiceParameters): Promise<ExecutionResult<PacketViewModel>> {
        return this.$apiService.sendAuth("IEmployeePayHistoryService/CreatePayrollProcessForVoid", parameters);
    }
    DeletePayrollProcessForReverseAndReissue(packetId: string): Promise<boolean> {
        return this.$apiService.sendAuth("IEmployeePayHistoryService/DeletePayrollProcessForReverseAndReissue", packetId);
    }
    GetEmployeePayHistory(pEmployeePayHeaderId: string): Promise<EmployeePayHistoryViewModel> {
        return this.$apiService.sendAuth("IEmployeePayHistoryService/GetEmployeePayHistory", pEmployeePayHeaderId);
    }
    GetSelectACheckView(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IEmployeePayHistoryService/GetSelectACheckView");
    }
    RunUpdateForVoidProcess(pVoidPaymentViewModel: VoidPaymentViewModel): Promise<ExecutionResult<PacketViewModel>> {
        return this.$apiService.sendAuth("IEmployeePayHistoryService/RunUpdateForVoidProcess", pVoidPaymentViewModel);
    }
}
